import React from 'react';
import { 
  Box, 
  Typography, 
  Grid, 
  List, 
  ListItem, 
  ListItemText, 
  Paper
} from '@mui/material';

/**
 * SuggestionsColumn component
 * 
 * Displays a list of suggested questions for the chatbot
 * 
 * @param {Object} props Component props
 * @param {Array} props.suggestedQuestions Array of suggested question strings
 * @param {Function} props.onQuestionClick Callback when a question is clicked
 * @returns {JSX.Element} Rendered component
 */
const SuggestionsColumn = ({ suggestedQuestions, onQuestionClick }) => {
  return (
    <Grid container direction="column" sx={{ height: '100%' }}>
      <Grid item sx={{ mb: 2, ml: 2 }}>
        <Typography variant="h4" sx={{ textAlign: 'left', color: 'text.primary' }}>
          Sugerencias
        </Typography>
      </Grid>
      <Grid item sx={{ overflowY: 'auto', flexGrow: 1 }}>
        <Box sx={{
          borderRadius: 2,
          height: '100%',
          width: '100%'
        }}>
          <List>
            {suggestedQuestions.map((question, index) => (
              <ListItem 
                  key={index}
                sx={{ 
                  mb: 2,
                  cursor: 'pointer'
                }}
                onClick={() => onQuestionClick(question)}
              >
                <ListItemText 
                  primary={
                    <Typography 
                      variant="h6" 
                      color="primary"
                      sx={{
                        '&:hover': {
                          textDecoration: 'underline'
                        }
                      }}
                    >
                      {question}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Grid>
    </Grid>
  );
};

export default SuggestionsColumn;
